type EnglishTextConstants = {
  contactUsModalTitle: string;
  contactUsDomesticText: string;
  contactUsInternationalText: string;
  contactUsLinkText: string;
};

const englishTextConstants: EnglishTextConstants = {
  //Contact us modal
  contactUsModalTitle: "Contact us",
  contactUsDomesticText: "Inside Australia",
  contactUsInternationalText: "Outside Australia",

  //Contact us link
  contactUsLinkText: "Contact Us",
};

type BrandContactNumbers = {
  contactUsDomesticNumber: string;
  domesticNumberText: string;
  contactUSInternationalNumber: string;
  internationalNumberText: string;
};

const brandContactNumbers = (brand?: string): BrandContactNumbers => {
  switch (brand) {
    case "gu":
      return {
        contactUsDomesticNumber: "tel:1800249966",
        domesticNumberText: "1800 249 966",
        contactUSInternationalNumber: "tel:+61296924438",
        internationalNumberText: "+61 2 9692 4438",
      };
    case "cignagu":
      return {
        contactUsDomesticNumber: "tel:1800124214",
        domesticNumberText: "1800 124 214",
        contactUSInternationalNumber: "tel:+61296924436",
        internationalNumberText: "+61 2 9692 4436",
      };
    case "nib":
    default:
      return {
        contactUsDomesticNumber: "tel:131642",
        domesticNumberText: "13 16 42",
        contactUSInternationalNumber: "tel:+61296924300",
        internationalNumberText: "+61 2 9692 4300",
      };
  }
};

type ContactUsConstants = EnglishTextConstants & BrandContactNumbers;

export const contactUsConstants = (language: string, brand: string): ContactUsConstants => {
  switch (language) {
    case "english":
      return {
        ...englishTextConstants,
        ...brandContactNumbers(brand),
      };
    default:
      return {
        ...englishTextConstants,
        ...brandContactNumbers(brand),
      };
  }
};
